// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryQueryHook on POST /team/get.

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type {
  typeTeamGetBody,
  typeTeamGetOutput200,
} from "../../sdk/team/postTeamGet";
import useCallSdk from "../../sdk-helpers/useCallSdk";

export function buildTeamGetQueryKey(payload: typeTeamGetBody): string[] {
  const queryKeySegments: string[] = [];
  queryKeySegments.push(`teamId:${JSON.stringify(payload.teamId)}`);
  return ["post:team:teamGet", "svc:sports-api", ...queryKeySegments];
}

type QueryOptions = Partial<
  UseQueryOptions<typeTeamGetOutput200, unknown, typeTeamGetOutput200, string[]>
> & {
  // Isolates two callers that query the same data for independent UI state
  // (e.g. a dropdown search vs a table both listing the same resource).
  queryKeyIdentifier?: string;
};

export default function useTeamGet(
  payload: typeTeamGetBody,
  options?: QueryOptions,
) {
  // No staleTime default here on purpose. Freshness is the consuming app's
  // decision and belongs in its QueryClient, in one place: a default set on the
  // hook would silently beat it for every screen. Pass one per call to override.
  const resolvedOptions = options ?? {};

  let queryKey = buildTeamGetQueryKey(payload);
  if (resolvedOptions.queryKeyIdentifier) {
    queryKey = [...queryKey, resolvedOptions.queryKeyIdentifier];
  }

  const { callSdk } = useCallSdk();
  return useQuery({
    queryKey,
    queryFn: () => callSdk().postTeamGet(payload),
    ...resolvedOptions,
  });
}
